import request from './axios';

/**
 * 获取产品列表
 * @returns {Promise<Object>} 返回产品列表
 */
export function getProductList(params,data) {
  return request({
    url: '/no-auth/product/list',
    method: 'post',
    data,
    params
  });
}

/**
 * 获取产品详情
 * @param {String} id 产品ID
 * @returns {Promise<Object>} 返回产品详情
 */
export function getProductDetail(id) {
  return request({
    url: `/no-auth/product/detail/${id}`,
    method: 'get'
  });
} 

/**
 * 获取产品配置
 * @param {String} id 分类ID
 * @returns {Promise<Object>} 返回产品配置
 */
export function getProductConfig(id) {
  return request({
    url: `/no-auth/product/config/${id}`,
    method: 'get'
  });
} 

/**
 * 获取分类
 * @returns {Promise<Object>} 返回分类列表
 */
export function getCategoryAll() {
  return request({
    url: '/no-auth/category/all-categories',
    method: 'get'
  });
}